import { useRefinementList } from 'react-instantsearch';

export const VirtualRefinementList = ({ attribute }: { attribute: string }) => {
  useRefinementList({ attribute });
  return null;
};
